(() => {
  if (window.semboniaSortSheetReady) return;
  window.semboniaSortSheetReady = true;
  const mobile = matchMedia('(max-width:809.98px)');
  const mobileBaseline = () => window.semboniaMobileBaseline?.instantDrawers === true;
  let current;
  const watched = new WeakSet();
  const desktopMenus = new WeakMap();
  function exitDesktopMenu(sort, menu) {
    if (sort.querySelector('.sembonia-sort-exiting')) return;
    const visual = menu.isConnected ? getComputedStyle(menu) : null;
    const exit = menu.cloneNode(true);
    exit.style.removeProperty('visibility');
    exit.style.setProperty('--sort-exit-opacity', visual?.opacity || '1');
    exit.style.setProperty('--sort-exit-transform', visual?.transform || 'none');
    exit.classList.add('sembonia-sort-exiting');
    exit.inert = true;
    exit.setAttribute('aria-hidden','true');
    // Make the handover before Vue removes its node; never reset opacity to 1.
    sort.querySelector('.sq-dropdown-wrapper').append(exit);
    if (menu.isConnected) menu.style.setProperty('visibility','hidden','important');
    desktopMenus.set(sort, null);
    setTimeout(() => exit.remove(), 500);
  }
  window.addEventListener('click', event => {
    if (mobile.matches || !(event.target instanceof Element)) return;
    document.querySelectorAll('.sembonia-collection-sort').forEach(sort => {
      const menu = sort.querySelector('.sq-dropdown-menu:not(.sembonia-sort-exiting)');
      if (!menu) {
        if (sort.contains(event.target) && event.target.closest('.sq-sort')) {
          sort.querySelectorAll('.sembonia-sort-exiting').forEach(exit => exit.remove());
        }
        return;
      }
      if (menu.style.visibility === 'hidden') return;
      if (!sort.contains(event.target) || event.target.closest('.sq-sort,.sq-option')) exitDesktopMenu(sort,menu);
    });
  }, true);
  function close(immediate = false, closeNative = true) {
    immediate = immediate || mobileBaseline();
    const state = current;
    if (!state) return;
    if (state.closing) {
      if (immediate) {
        clearTimeout(state.closeTimer);
        clearTimeout(state.closeDelay);
        state.layer.remove();
        window.semboniaScrollLock?.release(state.layer);
        current = null;
        if (state.trigger.isConnected) state.trigger.focus({preventScroll:true});
      }
      return;
    }
    state.closing = true;
    clearTimeout(state.openTimer);
    if (immediate) state.layer.classList.remove('is-open');
    else state.closeDelay = setTimeout(() => state.layer.classList.remove('is-open'), 100);
    state.trigger.setAttribute('aria-expanded', 'false');
    if (closeNative && state.menu.isConnected) state.trigger.click();
    const finish = () => {
      state.layer.remove();
      window.semboniaScrollLock?.release(state.layer);
      if (current === state) current = null;
      if (state.trigger.isConnected) state.trigger.focus({preventScroll:true});
    };
    if (immediate) finish();
    else state.closeTimer = setTimeout(finish, 500);
  }
  function open(menu) {
    if (current || !mobile.matches) return;
    const trigger = menu.closest('.sembonia-collection-sort')?.querySelector('.sq-sort');
    if (!trigger) return;
    const layer = document.createElement('div');
    layer.className = 'sembonia-sort-layer';
    layer.innerHTML = '<div class="sembonia-sort-backdrop"></div><section class="sembonia-sort-sheet" role="dialog" aria-modal="true" aria-labelledby="sembonia-sort-title" tabindex="-1" data-lenis-prevent><button type="button" class="sembonia-sort-handle" aria-label="Close sort options"></button><header><h2 id="sembonia-sort-title">Sort by</h2></header><div class="sembonia-sort-options"></div></section>';
    const list = layer.querySelector('.sembonia-sort-options');
    const options = [...menu.querySelectorAll('.sq-option')];
    // MUJI places the current selection first; retain Sparq's own option handlers.
    options.sort((a,b) => Number(b.classList.contains('sq-active')) - Number(a.classList.contains('sq-active')));
    options.forEach(option => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = option.textContent.trim();
      button.setAttribute('aria-pressed', String(option.classList.contains('sq-active')));
      button.addEventListener('click', () => {
        if (current?.closing) return;
        if (!option.isConnected) { close(); return; }
        option.click();
        close(false, false);
      });
      list.append(button);
    });
    document.body.append(layer);
    current = {layer, menu, trigger, closing:false};
    const state = current;
    trigger.setAttribute('aria-expanded','true');
    window.semboniaScrollLock?.acquire(layer);
    layer.querySelector('.sembonia-sort-backdrop').addEventListener('click', () => close());
    layer.querySelector('.sembonia-sort-handle').addEventListener('click', () => close());
    let dragStart;
    const handle = layer.querySelector('.sembonia-sort-handle');
    handle.addEventListener('touchstart', event => { dragStart = event.touches[0]?.clientY; }, {passive:true});
    handle.addEventListener('touchend', event => {
      if (dragStart != null && event.changedTouches[0]?.clientY - dragStart > 40) close();
      dragStart = null;
    }, {passive:true});
    layer.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const controls = [...layer.querySelectorAll('button')];
      const first = controls[0], last = controls[controls.length-1];
      if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
    });
    const finishOpen = () => {
      if (current !== state || state.closing) return;
      layer.classList.add('is-open');
      layer.querySelector('.sembonia-sort-handle').focus({preventScroll:true});
    };
    if (mobileBaseline()) finishOpen();
    else state.openTimer = setTimeout(finishOpen, 100);
  }
  function sync() {
    if (current && !current.menu.isConnected) close(false, false);
    document.querySelectorAll('.sembonia-collection-sort').forEach(sort => {
      sort.classList.add('sembonia-sort-enhanced');
      const trigger = sort.querySelector('.sq-sort');
      const menu = sort.querySelector('.sq-dropdown-menu:not(.sembonia-sort-exiting)');
      const previousMenu = desktopMenus.get(sort);
      desktopMenus.set(sort, mobile.matches || menu?.style.visibility === 'hidden' ? null : menu);
      if (!mobile.matches && previousMenu && !previousMenu.isConnected && !menu) {
        exitDesktopMenu(sort, previousMenu);
      }
      if ((menu && menu.style.visibility !== 'hidden') || mobile.matches) sort.querySelectorAll('.sembonia-sort-exiting').forEach(exit => exit.remove());
      if (trigger && !trigger.hasAttribute('role')) {
        trigger.setAttribute('role','button'); trigger.tabIndex = 0;
        trigger.setAttribute('aria-label','Sort by');
        trigger.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {event.preventDefault();trigger.click();}
          if (event.key === 'Escape' && sort.querySelector('.sq-dropdown-menu')) trigger.click();
        });
      }
      if (trigger) trigger.setAttribute('aria-expanded',String(!!menu));
      menu?.querySelectorAll('.sq-option').forEach(option => {
        if (option.hasAttribute('tabindex')) return;
        option.tabIndex = 0;
        option.setAttribute('role','button');
        option.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {event.preventDefault(); option.click();}
          if (event.key === 'Escape') {trigger.click(); trigger.focus();}
        });
      });
      if (menu && mobile.matches) open(menu);
    });
  }
  function start() {
    if (!document.body.matches('.page-collection,.page-search')) return;
    document.querySelectorAll('.sq-app').forEach(root => {
      if (watched.has(root)) return;
      watched.add(root);
      new MutationObserver(sync).observe(root,{childList:true,subtree:true});
    });
    sync();
  }
  mobile.addEventListener('change', () => {close(true); sync();});
  window.addEventListener('sembonia:mobile-baseline-change', () => {
    if (!mobileBaseline() || !current) return;
    if (current.closing) { close(true); return; }
    clearTimeout(current.openTimer);
    current.layer.classList.add('is-open');
  });
  window.addEventListener('pagehide', () => close(true));
  document.addEventListener('shopify:section:unload', () => close(true));
  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
